export const partnerData = {
    "event": {
        "exhibitorsTypes": [
            {
                "name": "host-partner",
                "id": "RmllbGRWYWx1ZV8yMzkwMTI2Ng==",
                "position": 0
            },
            {
                "name": "Host Sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "position": 0
            },
            {
                "name": "strategic-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "position": 0
            },
            {
                "name": "founding-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1Mg==",
                "position": 0
            },
            {
                "name": "enablement-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE0OQ==",
                "position": 0
            },
            {
                "name": "country-pavilion-sponsors",
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "position": 0
            },
            {
                "name": "platinum-sponsors",
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "position": 0
            },
            {
                "name": "pavilion-sponosr",
                "id": "RmllbGRWYWx1ZV8yMzk0MjEyNQ==",
                "position": 0
            },
            {
                "name": "emerald-sponsor",
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "position": 0
            },
            {
                "name": "Gold Sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "position": 0
            },
            {
                "name": "Silver Sponsors",
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "position": 0
            },
            {
                "name": "grif-platinum-sponsor",
                "id": "RmllbGRWYWx1ZV8yMjcxMTI3Ng==",
                "position": 0
            },
            {
                "name": "grif-exhibitor",
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3OQ==",
                "position": 0
            },
            {
                "name": "Strategic Partner",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMQ==",
                "position": 0
            },
            {
                "name": "start-up-exhibitor",
                "id": "RmllbGRWYWx1ZV8yMzEwNjg2Mw==",
                "position": 0
            },
            {
                "name": "un-tourism-innovation-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "position": 0
            },
            {
                "name": "coffee-sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczNw==",
                "position": 0
            },
            {
                "name": "water-station-sponsor",
                "id": "RmllbGRWYWx1ZV8yNDE1NjE5Nw==",
                "position": 0
            },
            {
                "name": "after-party-host",
                "id": "RmllbGRWYWx1ZV8yMjQ0MjEzMw==",
                "position": 0
            },
            {
                "name": "confectionary-cafe-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA3OQ==",
                "position": 0
            },
            {
                "name": "refreshment-bar-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4MA==",
                "position": 0
            },
            {
                "name": "mini-golf-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzk0Mjg1Ng==",
                "position": 0
            },
            {
                "name": "clinic-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4Mg==",
                "position": 0
            },
            {
                "name": "networking-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4Mw==",
                "position": 0
            },
            {
                "name": "official-carriers",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4NA==",
                "position": 0
            },
            {
                "name": "media-partner",
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "position": 0
            },
            {
                "name": "supporter",
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "position": 0
            },
            {
                "name": "culinary-and-concept-tour-partners",
                "id": "RmllbGRWYWx1ZV8yMDc3MjE1MQ==",
                "position": 0
            },
            {
                "name": "Organiser",
                "id": "RmllbGRWYWx1ZV8xNTAzNDc1NQ==",
                "position": 0
            }
        ]
    },
    "exhibitors": [
        {
            "id": "RXhoaWJpdG9yXzE1MzYwNzY=",
            "name": "Hilton",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/4950663b82304c41b0f1265679f56640.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwNzc=",
            "name": "Ministry of Tourism - Saudi Arabia",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/6fe500b1aa6e4270b348e6e33633bdaa.png",
            "type": "Strategic Partner",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "name": "strategic-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwNzg=",
            "name": "Boutique Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9fe9047849114a3b91efa280faad978d.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwNzk=",
            "name": "Forsite Creative",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/655516d055f94997bc70e1a2520c11e8.png",
            "type": "Data Partner - Restaurant Invest",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMQ==",
                "name": "Strategic Partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODA=",
            "name": "Egis",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/19a92222ef0c4caf8001b3546835a85b.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODE=",
            "name": "Wyndham Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/d8f0924ea9164f218a5475faabf39906.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODI=",
            "name": "Minor Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/20354d1296ac462c9bbad94c60569581.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODM=",
            "name": "WhiteWater",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/ce9d10ad07204689be6f3f52c40a43a2.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODQ=",
            "name": "Rove Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/d2c1487560c3423fb490d96cb471da87.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODU=",
            "name": "QUO",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e78a6bd0f5c440889388c5057bf38508.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODY=",
            "name": "IHCL",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/57a3cd54a7b04558baf5aa653c5a1cb2.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODc=",
            "name": "HVS",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9352265026bf4ccfab49a005b1b8e1cc.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODg=",
            "name": "Knight Frank",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/97feda61a94243d0a0fd429d35d0a94f.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwODk=",
            "name": "LEVA Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/a1ef6eb8757140c8a64af6dc6397ac8c.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTA=",
            "name": "Compass Project Consulting",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/56281da37ef247f5b9175570b3e3ceb2.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTE=",
            "name": "Millennium Hotels & Resorts",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/0728d4210bc541b8b59a11aca8823df4.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTI=",
            "name": "Colliers",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/23d1fc19b52045d7bcdf507be7e0b47c.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTM=",
            "name": "Marriott International",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/030ebd0651d548a3945c86f06d3fc051.jpeg",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTQ=",
            "name": "Rotana",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/6840f7b93d9a473da7f0b64676f6215a.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTU=",
            "name": "ALEPH",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/997d458c00fb4e458857a94e384ff447.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTY=",
            "name": "Radisson Hotel Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e681d499cbfb4506aef54274593df93e.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTc=",
            "name": "NEOM",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/02f00839db2b4b5c87f2596c203ea173.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTg=",
            "name": "Mandarin Oriental Al Faisaliah, Riyadh",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e93786fc020046c6a98e962dc6f854ce.png",
            "type": "Host Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "name": "Host Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYwOTk=",
            "name": "Al Khozama",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/c29e48205eef486c9ad4e85d61193ccb.png",
            "type": "Host Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "name": "Host Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDA=",
            "name": "Kerten Hospitality",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/0048f8e47fa84438b3763dd6ee16fb53.jpeg",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDE=",
            "name": "Baheej",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/202d675c33ff4b2690e419f5432ed64a.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDI=",
            "name": "Saudi Icon",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/67ea24b32f00426db2add1c38b356246.jpeg",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDM=",
            "name": "ClubMed - All-Inclusive beach and mountain Resorts",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/78951d335917419f9631f697e86ee4ad.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDQ=",
            "name": "DAR Engineering",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/63b2c2c9a6ba4545acf7139375cd250a.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDU=",
            "name": "Domus Managed Housing",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/10b4f1bfa8564b8cbe4d3b0f7a16b51f.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDY=",
            "name": "Time Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/070bab2accb3488a81e7eab973079d1c.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzYxMDc=",
            "name": "STR",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/710b7f7af15e41b3a8c32be9904ba1e4.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NTUzODk=",
            "name": "ASFAR",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/8ffc4edbb4174bf7923a9e98d58329ee.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NTUzOTA=",
            "name": "BITS Arabia",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/cf0d7de263b147b28a30ffa389f155af.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NTUzOTE=",
            "name": "Shaza Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/1c2a152a63c54842bfd2a936a9932129.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzU5MTg=",
            "name": "Taiba Investments",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/892251890802481bacd5e524e46c462b.png",
            "type": "Founding Partner",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1Mg==",
                "name": "founding-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzY3MDE=",
            "name": "Red Sea Global",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/840416ae058446069c9e02d645798d66.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzY3MDk=",
            "name": "Rua Al Madinah",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/224d2433831542e9a574a9bb14ee661e.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1Nzc1MjA=",
            "name": "Louvre Hotels Group / Golden Tulip MENA ",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/d5f080b116e948d9b329055a8278c318.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1Nzg2ODY=",
            "name": "KAFD",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/6a7ed583e18e474e920fbdce2b7d08fe.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1ODA3NTU=",
            "name": "CBRE",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/3dacc22879004b219219915c9d08e513.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1ODc2NDg=",
            "name": "HAMA",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/153d554e84e04cbdbb143b7deab680c3.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1ODk5MTI=",
            "name": "Melitta Professional ",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/2720071bfae64a159fca3d6f00798b07.jpeg",
            "type": "Coffee Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczNw==",
                "name": "coffee-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTAxMzA=",
            "name": "JLL",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/658906dab03449d8a00db78bcbf22981.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTExNjU=",
            "name": "Al Futtaim Engineering & Technologies",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/07d2597a257249d88d3a8dd3f9eeed5b.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTI0MzI=",
            "name": "Sustainable Hospitality Alliance",
            "logoUrl": "https://static.swapcard.com/public/images/0eda437874424108bf03f8d02038e4b2.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTY0ODA=",
            "name": "Tourism Development Fund",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/5b40511227c1443e8777e963924c8b01.png",
            "type": "Enablement Partner",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE0OQ==",
                "name": "enablement-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTY1OTQ=",
            "name": "The Ascott Limited",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/1d28691941e54fe1901e6f6877e515a3.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTY2MTc=",
            "name": "Insignia",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e904d26f397d4f659d872e1103eba06c.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTgzNzE=",
            "name": "Wisefields",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9295d63b9ce84f1382db1fdbf509bee4.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDAwNjk=",
            "name": "TTN Worldwide",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/ebccd32f013e41c7a959fae80021bc5b.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDU3NTU=",
            "name": "Eye of Riyadh",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/69f83dc71d9e4cc2a13d10133e03d7b3.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDU3NTY=",
            "name": "Argaam",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9035cc4754d94e9ebdc186295c09013e.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDU3NjI=",
            "name": "TravTalk",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/65cd743b407342669d49508aa47ac9f8.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDY3MzQ=",
            "name": "Jabal Omar Development Company",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/b208b52bbae5439f82cedea1ceaf2f39.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTExMTE=",
            "name": "H World International",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/5350a259437e4175859ef344aa373369.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTMxNzM=",
            "name": "Hospitality Management Holding",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/94f7ee84e63b43159b5a493090a762af.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTMyNTY=",
            "name": "Elaf Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/7932baa4dd11455f981bc35ffbc1ccc7.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTQ2ODE=",
            "name": "KOHLER",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/c25af80fc57c4b39985a283b1750d570.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjAyMTQ=",
            "name": "IHG",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/05581500b0f3492c8925bb53f7e03677.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjA2MjY=",
            "name": "Accor",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/c62a803df9754fb8874df76d6b05d7c3.jpeg",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjA2Nzc=",
            "name": "JT & Partners",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/8cf9c9a5f15e4871920f66747a1814a6.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjA2OTU=",
            "name": "Soho Hospitality",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/1c80be2a1d9c40e599859c609f8c3df9.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjA3MDM=",
            "name": "Restroworks",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/ec279839f9394a7bab7f09cef40fff16.png",
            "type": "GRIF - Platinum Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMjcxMTI3Ng==",
                "name": "grif-platinum-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjExOTQ=",
            "name": "TGP International DMCC",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/589f1ec2080d4045a270842b33483d48.png",
            "type": "GRIF - Platinum Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMjcxMTI3Ng==",
                "name": "grif-platinum-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjEyMDU=",
            "name": "TV5Monde",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/eccd4e86ccb5406b88c0bcfa04c7b4b6.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjY1NTM=",
            "name": "Breaking Travel News",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/fa2cd697e97841579a2bab29d749c473.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MzI4MzA=",
            "name": "Tashyid Urban Development",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e54acde95f3b43afbc77d6f09393bb12.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MzI4NzY=",
            "name": "ARC International Design Consultants",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/188b97066e004b04b989fcca849cb541.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MzI5OTA=",
            "name": "UN Tourism",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/c71181db7bbe4c4c808d2ac04c741e41.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MzM0NDA=",
            "name": "Valor Hospitality Partners",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/3198f8cc303340639eea9105afdae346.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NDc0NzA=",
            "name": "Daniel Ost",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e59ecd343a354f119f84a0c3c3f2f57e.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NTM2NDk=",
            "name": "ViaVii",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/936c2444cfd04d4d9003a8dbd83b0634.png",
            "type": "UN Tourism Innovation Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "name": "un-tourism-innovation-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NTY5MjI=",
            "name": "Matbakhi",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/89bd87f45da347fd9d69b73be3f92823.png",
            "type": "Start-up Exhibitor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzEwNjg2Mw==",
                "name": "start-up-exhibitor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NTcwMzk=",
            "name": "Keane",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/86af6de97f0d42bd82d66db0dab88f8b.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NTk5MDk=",
            "name": "Hospitality Services - Hospitality News Middle East",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/5188903ac2bb4219ab9e9a306dcb4f05.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NTk5MTE=",
            "name": "Connecting Travel",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/b0a6c08465934496ac0cbf095ec1ef30.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjI4NDg=",
            "name": "SparkleHaze",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/407e7291b2794728b85bc552492c9042.png",
            "type": "UN Tourism Innovation Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "name": "un-tourism-innovation-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjMwMTQ=",
            "name": "Conran Design Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/357cadda18f1468ba0a2f20b7c906770.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjMyNzk=",
            "name": "Cool Inc",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/aba4761da1354a1f92cdd370026ce7c3.png",
            "type": "Culinary & Concept Tour Partner",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDc3MjE1MQ==",
                "name": "culinary-and-concept-tour-partners"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjQ0MjI=",
            "name": "Dan Company",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/93fedcf6efdc49b3b247523b757dc698.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjU4MzM=",
            "name": "Arab News",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/2ec375339d2849a2ac36f01e2acfe7fc.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjY0MjI=",
            "name": "PwC",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/fbb35101ae4347bdb3a4e72a650459e4.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjY0MjY=",
            "name": "Hyatt",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/0f486d244335484ea7857aae736e1feb.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2Njc4MDA=",
            "name": "Xenios Academy",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/a1acaf82766f4272802fe10c62ad52f5.png",
            "type": "UN Tourism Innovation Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "name": "un-tourism-innovation-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2Njc4MTA=",
            "name": "CNN Business Arabic",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e871d598f1d14e69a83b53e2ca280755.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2Nzc0NjQ=",
            "name": "MJS",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/8ca031aaaab3438fa365a8eaaf57bd5b.png",
            "type": "GRIF - Platinum Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMjcxMTI3Ng==",
                "name": "grif-platinum-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2Nzc0NjU=",
            "name": "Nimblebot.ai",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/4ccdc2caf3c946c282a23e4063223e34.png",
            "type": "UN Tourism Innovation Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "name": "un-tourism-innovation-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2ODczNjI=",
            "name": "Inhabitr",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/298a1afb35ee4610ae2e8e91fc352321.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2ODkyOTA=",
            "name": "Ladun Investment Company",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/ebde66c45de24176b3155cb724ec8026.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2ODkyOTk=",
            "name": "Katch",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/cc3ebfb7a6d5472c9fa3163e0ebdfdb7.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2ODk0NDE=",
            "name": "Arabian Business",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/4c2e42b60e1b4b28b3798b0578f90aa8.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2OTM2MTM=",
            "name": "Oxford Business Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/1d38279e6a4545738132a21a73f5526e.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2OTU4MTY=",
            "name": "Al Othaim Investments",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/be89e8bb05b64050b5ec146a3fd6d49e.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        }
    ]
}